'use client';

import Script from 'next/script';

export default function YotpoScript() {
  const yotpoAppKey = process.env.NEXT_PUBLIC_YOTPO_APP_KEY;

  return (
    <Script
      src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${yotpoAppKey}`}
      async
    />
  );
}
